import React, { useState, useEffect } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  IconButton,
  CircularProgress,
  Modal,
  Box,
  Button,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { GoSearch } from "react-icons/go";
import { AddMedicine } from "./addMedicine";
import { EditMedicine } from "./editMedicine";
import { axiosInstance } from "../../axiosInstance";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const columns = [
  // { id: "wholesalername", label: "WHOLESALER NAME", minWidth: 100, align: "center" },
  {
    id: "name",
    label: "MEDICINE NAME",
    minWidth: 170,
    align: "center",
  },
  {
    id: "type",
    label: "MEDICINE TYPE",
    minWidth: 170,
    align: "center",
  },
  { id: "actions", label: "ACTIONS", minWidth: 100, align: "center" },
];

function createData(name, type) {
  return { name, type };
}

const rows = [
  createData("Paracetamol", "Medicine"),
  createData("Product Name", "Surgical"),
  createData("Paracetamol", "Medicine"),
  createData("Product Name", "Surgical"),
  createData("Paracetamol", "Medicine"),
  createData("Product Name", "Surgical"),
];

export function ListMedicine() {
  const [medicineList, setMedicineList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const navigate = useNavigate();

  // const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(30);
  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  // };

  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(+event.target.value);
  //   setPage(0);
  // };

  // save table page size in local to save data on page change
  const [page, setPage] = useState(() => {
    const saved = localStorage.getItem("medicine_page");
    return saved ? Number(saved) : 0;
  });

  const [rowsPerPage, setRowsPerPage] = useState(() => {
    const saved = localStorage.getItem("medicine_rowsPerPage");
    return saved ? Number(saved) : 20;
  });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    localStorage.setItem("medicine_page", newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const value = Number(event.target.value);

    setRowsPerPage(value);
    setPage(0);

    localStorage.setItem("medicine_rowsPerPage", value);
    localStorage.setItem("medicine_page", 0);
  };

  const fetchMedicines = async (pageNumber = 0, pageSize = rowsPerPage) => {
    setLoading(true);
    setError("");
    try {
      const res = await axiosInstance.get(
        `/admin/master-medicine/?page=${pageNumber + 1}&page_size=${pageSize}`
      );

      if (res.data.results?.status === "success") {
        setMedicineList(res.data.results.data || []);
        setTotalCount(res.data.count || 0);
      } else {
        setError("Failed to fetch Medicines data.");
      }
    } catch (err) {
      console.error("❌ Error fetching Medicines data:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchMedicines();
  // }, []);
  useEffect(() => {
    fetchMedicines(page, rowsPerPage, searchQuery);
  }, [page, rowsPerPage, searchQuery]);

  const filteredData = medicineList.filter((row) =>
    row.name?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div>
      <div className="admin-top-container">
        <div className="admin-listText">Manage Medicine</div>
        {/* <div>
          <select
            className="listAdmin-showRecords"
            value={rowsPerPage}
            onChange={handleChangeRowsPerPage}
          >
            <option value={20}>Show No of Records</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={500}>500</option>
            <option value={1000}>1000</option>
            <option value={2000}>2000</option>
            <option value={5000}>5000</option>
          </select>
        </div> */}
        <div className="search-container">
          <div className="nav-search ">
            <span className="search-icons">
              <GoSearch />
            </span>
            <input
              type="text"
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        </div>
        <div className="btnAdd">
          <button onClick={() => navigate("/medicine-add")}>
            + Add Medicine
          </button>
        </div>
      </div>
      <Paper sx={{ width: "100%", overflow: "hidden" }}>
        <TableContainer sx={{ maxHeight: 440 }} className="Table-container">
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                    className="table-header"
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={columns.length} align="center">
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : filteredData.length > 0 ? (
                filteredData
                  // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => (
                    <TableRow
                      className="table-row"
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={index}
                      sx={{
                        backgroundColor: index % 2 === 1 ? "#E7F0F9" : "white",
                      }}
                    >
                      {columns.map((column) => {
                        const value = row[column.id];
                        const isNameMatch =
                          column.id === "name" &&
                          value
                            ?.toLowerCase()
                            .includes(searchQuery.toLowerCase());
                        return (
                          <TableCell
                            key={column.id}
                            align={column.align}
                            className={`${column.id}-medicine tableCelldata`}
                          >
                            {column.id === "actions" ? (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  gap: "8px",
                                }}
                              >
                                <IconButton sx={{ color: "black" }}>
                                  <EditIcon
                                    style={{
                                      cursor: "pointer",
                                      fontSize: "18px",
                                    }}
                                    onClick={() =>
                                      navigate(
                                        `/medicine-edit/${row.medicine_id}`
                                      )
                                    }
                                  />
                                </IconButton>
                              </div>
                            ) : value === null ||
                              value === undefined ||
                              value === "" ? (
                              "--"
                            ) : column.id === "type" ? (
                              value.toUpperCase()
                            ) : (
                              value
                            )}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  ))
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={columns.length}
                    align="center"
                    style={{ padding: "40px 0" }}
                  >
                    No Data Available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[20, 30, 50, 100, 500, 1000, 2000, 5000, 10000]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}
